import { Progress } from '@nextui-org/react'
import { FC } from 'react'
import { getTradeinProgressPercent } from '@/utils/tradeinNextStep'

interface StepProgressProps {
  item: any
}

const StepProgress: FC<StepProgressProps> = ({ item }) => {
  const percent = getTradeinProgressPercent(item)

  return (
    <div className='flex items-center gap-2 min-w-[110px]'>
      <Progress
        aria-label='Avance del tradein'
        value={percent}
        size='sm'
        className='max-w-[90px]'
        classNames={{ indicator: percent === 100 ? 'bg-[#4b75f7]' : 'bg-[#37417f]' }}
      />
      <span className='text-tiny text-slate-500 whitespace-nowrap'>{percent}%</span>
    </div>
  )
}

export default StepProgress
